import React, {forwardRef} from 'react';
import {ShotMapGoalViewComposer} from "./shot-map.goal-view.composer";
import styles from './shot-map-goal-view.module.scss';
import classnames from "classnames";
import {ShotMapGoalViewDetails} from "./shot-map.goal-view.details";
import {ShotMapGoalViewContent} from "./shot-map.goal-view.content";


export const ShotMapGoalView = ShotMapGoalViewComposer(forwardRef(({
                                                                     events,
                                                                     controller,
                                                                     containerHeight,
                                                                     selectedShot,
                                                                     selectedEvent,
                                                                     goalFrame,
                                                                     isPlayerPopup,
                                                                     game,
                                                                     onChange,
                                                                     forceAllShotsActive,
                                                                     shouldRenderEventDetails = true
                                                                   }, ref) => {
  const {device: {isSmallView}} = controller;

  const contentProps = {
    containerHeight,
    goalFrame,
    events,
    game,
    onChange
  }

  const detailsProps = {
    selectedEvent,
    controller
  }

  return (
    <div className={classnames(styles.container, {[styles.small_view]: isSmallView, [styles.game]: game, [styles.popup]: isPlayerPopup})}>
      <div className={classnames(styles.content_container, {[styles.all_active]: forceAllShotsActive, [styles.border]: !shouldRenderEventDetails})}>
        <ShotMapGoalViewContent {...contentProps} ref={ref}/>
        {shouldRenderEventDetails ? <ShotMapGoalViewDetails {...detailsProps}/> : null}
      </div>
    </div>
  )
}))
